import { getJSON } from 'bv-fetch';
import { logged_in as loggedIn } from 'state';

export default () => (
  getJSON(`/api/right_components?l=${loggedIn()}`)
);
